{
  "colorPalette": {
    "primary": "#13455B",
    "secondary": "#1F7A8C",
    "accent": "#C4662B",
    "positive": "#3B7A57",
    "negative": "#a23b2b"
  },
  "variableMap": {
    "nationalPriorities": "Q7",
    "energyPriority": "Q10",
    "futureDemand": "Q13",
    "renewablesView": "Q11",
    "renewablesCompetitiveness": "Q12",
    "comfortDrivers": "Q34",
    "electricityBillChange": "Q8r1",
    "fuelCostBlame": "Q9r1",
    "gender": "Q2",
    "education": "Q5",
    "income": "Q6",
    "region": "HQREGION"
  },
  "sections": {
    "sec-overview": {
      "id": "sec-overview",
      "name": "Overview",
      "pages": {
        "page-summary": {
          "id": "page-summary",
          "name": "Executive Summary",
          "subheader": "The headlines",
          "pageSections": {
            "blk-exec-summary": {
              "id": "blk-exec-summary",
              "segmentLocation": "full",
              "reportType": "headline-stats",
              "reportExtraData": {
                "boxes": [
                  {
                    "value": "72%",
                    "label": "Aided awareness"
                  },
                  {
                    "value": "+31",
                    "label": "Advocacy score"
                  },
                  {
                    "value": "Reliability",
                    "label": "Top driver"
                  },
                  {
                    "value": "Up 8 pts",
                    "label": "Momentum"
                  }
                ],
                "takeaways": [
                  "Awareness is high but advocacy lags it by 40 points.",
                  "Reliability outranks price as the top driver for the first time.",
                  "Momentum is strongest among 35-54s, who moved 12 points."
                ]
              }
            }
          },
          "pageSectionOrder": [
            "blk-exec-summary"
          ]
        },
        "page-kpi": {
          "id": "page-kpi",
          "name": "Single-KPI Dial",
          "subheader": "One score shown against its scale for an at-a-glance read",
          "pageSections": {
            "blk-kpi-dial": {
              "id": "blk-kpi-dial",
              "segmentLocation": "full",
              "reportType": "kpi-score",
              "reportExtraData": {
                "value": "72",
                "label": "Brand Advocacy Score",
                "scaleMax": 100
              }
            }
          },
          "pageSectionOrder": [
            "blk-kpi-dial"
          ]
        },
        "page-methodology": {
          "id": "page-methodology",
          "name": "Methodology",
          "subheader": "How this study was run",
          "pageSections": {
            "blk-methodology": {
              "id": "blk-methodology",
              "segmentLocation": "full",
              "reportType": "study-overview",
              "reportExtraData": {
                "incidenceRate": "35%",
                "market": "DFW",
                "notesHeading": "How this study was run",
                "notes": "Online survey of adults aged 18+ in the Dallas-Fort Worth metro.\n- Fielded 16-17 December 2025\n- Quotas set on age, gender and region\n- Data weighted to census profile\nPercentages are of respondents answering each question."
              }
            }
          },
          "pageSectionOrder": [
            "blk-methodology"
          ]
        }
      },
      "pageOrder": [
        "page-summary",
        "page-kpi",
        "page-methodology"
      ]
    },
    "sec-priorities": {
      "id": "sec-priorities",
      "name": "Energy Priorities",
      "pages": {
        "page-priorities": {
          "id": "page-priorities",
          "name": "National Priorities",
          "subheader": "What the public puts first for America's future",
          "pageSections": {
            "blk-national-priorities": {
              "id": "blk-national-priorities",
              "header": "Top three priorities for America's future",
              "segmentLocation": "full",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "nationalPriorities"
                ],
                "orientation": "horizontal",
                "sortDescending": true
              }
            },
            "blk-energy-priority": {
              "id": "blk-energy-priority",
              "header": "Priority for America's energy future",
              "segmentLocation": "left",
              "reportType": "pie-chart",
              "reportExtraData": {
                "variableKey": "energyPriority"
              }
            },
            "blk-future-demand": {
              "id": "blk-future-demand",
              "header": "Expected future electricity demand",
              "segmentLocation": "right",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "futureDemand"
                ],
                "orientation": "horizontal"
              }
            }
          },
          "pageSectionOrder": [
            "blk-national-priorities",
            "blk-energy-priority",
            "blk-future-demand"
          ]
        }
      },
      "pageOrder": [
        "page-priorities"
      ]
    },
    "sec-renewables": {
      "id": "sec-renewables",
      "name": "Renewable Energy",
      "pages": {
        "page-views": {
          "id": "page-views",
          "name": "Views on Renewables",
          "subheader": "How the industry is seen, and whether it helps America compete",
          "pageSections": {
            "blk-renewables-view": {
              "id": "blk-renewables-view",
              "header": "View of the U.S. renewable energy industry",
              "segmentLocation": "full",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "renewablesView"
                ],
                "orientation": "horizontal",
                "sortDescending": true
              }
            },
            "blk-competitiveness": {
              "id": "blk-competitiveness",
              "header": "Effect on America's ability to compete globally",
              "segmentLocation": "full",
              "reportType": "pie-chart",
              "reportExtraData": {
                "variableKey": "renewablesCompetitiveness"
              }
            },
            "blk-competitiveness-donut": {
              "id": "blk-competitiveness-donut",
              "header": "The same question as a donut",
              "segmentLocation": "full",
              "reportType": "donut-chart",
              "reportExtraData": {
                "variableKey": "renewablesCompetitiveness"
              }
            }
          },
          "pageSectionOrder": [
            "blk-renewables-view",
            "blk-competitiveness",
            "blk-competitiveness-donut"
          ]
        },
        "page-total-vs-filter": {
          "id": "page-total-vs-filter",
          "name": "Total vs Filter",
          "subheader": "Where the filtered subgroup parts company with everyone",
          "pageSections": {
            "blk-view-distribution": {
              "id": "blk-view-distribution",
              "header": "View of the renewable energy industry",
              "segmentLocation": "full",
              "reportType": "filter-comparison",
              "reportExtraData": {
                "variableKey": "renewablesView",
                "orientation": "horizontal",
                "sortDescending": true
              }
            },
            "blk-education-distribution": {
              "id": "blk-education-distribution",
              "header": "Highest level of education completed",
              "segmentLocation": "full",
              "reportType": "filter-comparison",
              "reportExtraData": {
                "variableKey": "education",
                "orientation": "vertical"
              }
            }
          },
          "pageSectionOrder": [
            "blk-view-distribution",
            "blk-education-distribution"
          ]
        },
        "page-comfort": {
          "id": "page-comfort",
          "name": "Local Infrastructure",
          "subheader": "What would increase comfort with clean energy projects nearby",
          "pageSections": {
            "blk-comfort-drivers": {
              "id": "blk-comfort-drivers",
              "header": "What would make people more comfortable with clean energy infrastructure",
              "segmentLocation": "full",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "comfortDrivers"
                ],
                "orientation": "horizontal",
                "sortDescending": true,
                "topN": 6
              }
            },
            "blk-comfort-donuts": {
              "id": "blk-comfort-donuts",
              "header": "The same options as a donut per option",
              "segmentLocation": "full",
              "reportType": "donut-chart",
              "reportExtraData": {
                "variableKey": "comfortDrivers"
              }
            }
          },
          "pageSectionOrder": [
            "blk-comfort-drivers",
            "blk-comfort-donuts"
          ]
        }
      },
      "pageOrder": [
        "page-views",
        "page-total-vs-filter",
        "page-comfort"
      ]
    },
    "sec-costs": {
      "id": "sec-costs",
      "name": "Cost of Energy",
      "pages": {
        "page-bills": {
          "id": "page-bills",
          "name": "Bills & Blame",
          "subheader": "How bills have moved, and what people hold responsible",
          "pageSections": {
            "blk-bill-change": {
              "id": "blk-bill-change",
              "header": "Change in electricity bills over the past year",
              "segmentLocation": "left",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "electricityBillChange"
                ],
                "orientation": "horizontal"
              }
            },
            "blk-fuel-blame": {
              "id": "blk-fuel-blame",
              "header": "How much rising oil and gas costs are blamed",
              "segmentLocation": "right",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "fuelCostBlame"
                ],
                "orientation": "horizontal"
              }
            }
          },
          "pageSectionOrder": [
            "blk-bill-change",
            "blk-fuel-blame"
          ]
        },
        "page-cost-drivers": {
          "id": "page-cost-drivers",
          "name": "Cost Drivers by Group",
          "subheader": "The same question repeated per group, every panel on one shared scale",
          "pageSections": {
            "blk-cost-drivers": {
              "id": "blk-cost-drivers",
              "header": "Rising fuel costs as a driver of bills, by gender",
              "segmentLocation": "full",
              "reportType": "subgroup-panels",
              "reportExtraData": {
                "variableKey": "fuelCostBlame",
                "groupBy": "gender",
                "orientation": "vertical",
                "columns": 3
              }
            },
            "blk-demand-vs-bills": {
              "id": "blk-demand-vs-bills",
              "header": "View of the renewable energy industry, by education",
              "segmentLocation": "full",
              "reportType": "subgroup-panels",
              "reportExtraData": {
                "variableKey": "renewablesView",
                "groupBy": "education",
                "orientation": "horizontal",
                "sortDescending": true
              }
            }
          },
          "pageSectionOrder": [
            "blk-cost-drivers",
            "blk-demand-vs-bills"
          ]
        }
      },
      "pageOrder": [
        "page-bills",
        "page-cost-drivers"
      ]
    },
    "sec-sample": {
      "id": "sec-sample",
      "name": "Sample",
      "pages": {
        "page-profile": {
          "id": "page-profile",
          "name": "Respondent Profile",
          "subheader": "Who took part in the study",
          "pageSections": {
            "blk-gender": {
              "id": "blk-gender",
              "header": "Gender",
              "segmentLocation": "left",
              "reportType": "pie-chart",
              "reportExtraData": {
                "variableKey": "gender"
              }
            },
            "blk-region": {
              "id": "blk-region",
              "header": "Region",
              "segmentLocation": "right",
              "reportType": "pie-chart",
              "reportExtraData": {
                "variableKey": "region"
              }
            },
            "blk-education": {
              "id": "blk-education",
              "header": "Highest level of education completed",
              "segmentLocation": "left",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "education"
                ],
                "orientation": "horizontal",
                "sortDescending": true
              }
            },
            "blk-income": {
              "id": "blk-income",
              "header": "Household annual income",
              "segmentLocation": "right",
              "reportType": "bar-chart",
              "reportExtraData": {
                "variableKeys": [
                  "income"
                ],
                "orientation": "vertical"
              }
            }
          },
          "pageSectionOrder": [
            "blk-gender",
            "blk-region",
            "blk-education",
            "blk-income"
          ]
        }
      },
      "pageOrder": [
        "page-profile"
      ]
    }
  },
  "sectionOrder": [
    "sec-overview",
    "sec-priorities",
    "sec-renewables",
    "sec-costs",
    "sec-sample"
  ],
  "filters": {
    "compareBy": [
      "gender",
      "region",
      "education"
    ],
    "filterableValues": [
      "gender",
      "region",
      "education",
      "income"
    ]
  }
}
